module.exports = __webpack_public_path__ + "img/error.46218834.svg";